<template>
    <portal v-if="visible" to="modals-root">
        <div @click.stop="" class="modal is-active">
            <div @click.stop="$emit('close')" class="modal-background"></div>

            <div class="modal-card" :style="{minHeight, maxHeight}">
                <header v-if="show_header" class="modal-card-head">
                    <p v-if="title" class="modal-card-title">{{ title }}</p>
                    <button @click.stop="$emit('close')" class="delete"></button>
                </header>

                <section class="modal-card-body" :class="{'is-paddingless': !padding}">
                    <slot></slot>
                </section>
            </div>
        </div>
    </portal>
</template>

<script>
export default {
    name: 'BaseModal',
    props: {
        visible: Boolean,
        title: String,
        padding: { type: Boolean, default: true },
        show_header: { type: Boolean, default: true },
        minHeight: { type: String, default: '15rem' },
        maxHeight: { type: String, default: '35rem' },
    },
    inject: ['$validator'],
};
</script>

<style scoped>
    .modal {cursor: auto}
</style>
